import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

// Import components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Experience from "./components/Experience";
import Testimonials from "./components/Testimonials";
import Pricing from "./components/Pricing";
import CTA from "./components/CTA";
import Mission from "./components/Mission";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

// Import pages
import AncestralLineage from "./pages/AncestralLineage";
// import SocialFeed from "./pages/SocialFeed"; // Temporarily removed
import TribalVault from "./pages/TribalVault";
import CrestGenerator from "./pages/CrestGenerator";
import HealingGrounds from "./pages/HealingGrounds";
import LanguageRestoration from "./pages/LanguageRestoration";
import TribalTable from "./pages/TribalTable";
import Profile from "./pages/Profile";
import SubscriptionSimple from "./pages/SubscriptionSimple";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import PublicProfile from "./pages/PublicProfile";
import ProfileEdit from "./pages/ProfileEdit";
import DebugLogin from "./pages/DebugLogin";
import ExplorePage from "./pages/Explore";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPortal from "./pages/AdminPortal";
import SupportTicket from "./pages/SupportTicket";
import SupportTickets from "./pages/SupportTickets";
import AuthDebug from "./pages/AuthDebug";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CosmicCodes from "./pages/CosmicCodes";
import VideoCall from "./components/VideoCall";
import Register from "./pages/Register";

// Import context and UI
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { Toaster } from "./components/ui/toaster";
import ProtectedRoute from "./components/ProtectedRoute";
import SubscriptionBanner from "./components/SubscriptionBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Features />
      <Experience />
      <Testimonials />
      <Pricing />
      <CTA />
      <Mission />
      <Contact />
      <Footer />
    </div>
  );
};

const LineagePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <AncestralLineage />
      <Footer />
    </div>
  );
};

const VaultPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <TribalVault />
      <Footer />
    </div>
  );
};

const CrestPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <CrestGenerator />
      <Footer />
    </div>
  );
};

const HealingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <HealingGrounds />
      <Footer />
    </div>
  );
};

const LanguagePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <LanguageRestoration />
      <Footer />
    </div>
  );
};

const TablePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SubscriptionBanner />
      <TribalTable />
      <Footer />
    </div>
  );
};

const ProfilePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Profile />
      <Footer />
    </div>
  );
};

const SubscriptionPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <SubscriptionSimple />
      <Footer />
    </div>
  );
};

const SubscriptionSuccessPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-green-50 to-blue-50">
      <SubscriptionSuccess />
    </div>
  );
};

const AdminPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminDashboard />
    </div>
  );
};

const AdminPortalPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminPortal />
    </div>
  );
};

const SupportTicketPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <SupportTicket />
      <Footer />
    </div>
  );
};

const SupportTicketsPage = () => {
  return (
    <ProtectedRoute>
      <SupportTickets />
    </ProtectedRoute>
  );
};

const PublicProfilePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <PublicProfile />
    </div>
  );
};

const ProfileEditPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ProfileEdit />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/lineage" element={<ProtectedRoute><LineagePage /></ProtectedRoute>} />
            <Route path="/ancestral-lineage" element={<ProtectedRoute><LineagePage /></ProtectedRoute>} />
            <Route path="/vault" element={<ProtectedRoute><VaultPage /></ProtectedRoute>} />
            <Route path="/tribal-vault" element={<ProtectedRoute><VaultPage /></ProtectedRoute>} />
            <Route path="/crest" element={<ProtectedRoute><CrestPage /></ProtectedRoute>} />
            <Route path="/crest-generator" element={<ProtectedRoute><CrestPage /></ProtectedRoute>} />
            <Route path="/remedies" element={<ProtectedRoute><HealingPage /></ProtectedRoute>} />
            <Route path="/healing" element={<ProtectedRoute><HealingPage /></ProtectedRoute>} />
            <Route path="/healing-grounds" element={<ProtectedRoute><HealingPage /></ProtectedRoute>} />
            <Route path="/language" element={<ProtectedRoute><LanguagePage /></ProtectedRoute>} />
            <Route path="/language-restoration" element={<ProtectedRoute><LanguagePage /></ProtectedRoute>} />
            <Route path="/table" element={<ProtectedRoute><TablePage /></ProtectedRoute>} />
            <Route path="/tribal-table" element={<ProtectedRoute><TablePage /></ProtectedRoute>} />
            <Route path="/explore" element={<ExplorePage />} />
            {/* Tribal Feed temporarily removed - will be re-implemented later */}
            {/* <Route path="/feed" element={<SocialFeed />} /> */}
            <Route path="/cosmic-codes" element={<ProtectedRoute><CosmicCodes /></ProtectedRoute>} />
            <Route path="/video-call/:channelName" element={<ProtectedRoute><VideoCall /></ProtectedRoute>} />
            <Route path="/profile/:userId" element={<PublicProfilePage />} />
            <Route path="/public-profile/:userId" element={<PublicProfilePage />} />
            <Route path="/profile/edit" element={<ProfileEditPage />} />
            <Route path="/debug-login" element={<DebugLogin />} />
            <Route path="/auth-debug" element={<AuthDebug />} />
            <Route path="/login" element={<Home />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile" element={<ProfileEditPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin-portal" element={<AdminPortalPage />} />
            <Route path="/support-ticket" element={<SupportTicketPage />} />
            <Route path="/support-tickets" element={<SupportTicketsPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
